import nbMessages from "../locales/nb_NO";

const NbLang = {
  messages: {
    ...nbMessages,
  },
  locale: "nb-NO",
};
export default NbLang;
